import React from "react";
import { LIGHT_COLORS } from "./landingTheme";

/* ─────────────────────── CORPORATE LOGO ICON ─────────────────────── */
export const LogoIcon = ({ size = 48, color = LIGHT_COLORS.primaryMain, style = {} }) => (
    <svg viewBox="0 0 30.72 15.36" width={size} height={size / 2} fill={color} style={style}>
        <g>
            <rect x="13.2" y="5.52" width="1.44" height="1.44" />
            <rect x="11.76" y="5.52" width="1.44" height="1.44" />
            <rect x="10.32" y="5.52" width="1.44" height="1.44" />
            <rect x="8.88" y="5.52" width="1.44" height="1.44" />
            <rect x="7.44" y="5.52" width="6.95" height="1.44" />
            <rect x="13.2" y="2.64" width="1.44" height="1.44" />
            <rect x="11.76" y="2.64" width="1.44" height="1.44" />
            <rect x="10.32" y="2.64" width="1.44" height="1.44" />
            <rect x="8.88" y="2.64" width="1.44" height="1.44" />
            <rect x="7.44" y="2.64" width="7.2" height="1.44" />
            <rect x="21.84" y="11.28" width="1.44" height="1.44" />
            <rect x="7.44" y="11.28" width="15.84" height="1.44" />
            <rect x="7.44" y="6.34" width="1.44" height="2.51" />
            <rect x="7.44" y="8.4" width="6.39" height="1.44" />
            <rect x="8.88" y="8.4" width="1.44" height="1.44" />
            <rect x="10.32" y="8.4" width="1.44" height="1.44" />
            <rect x="11.76" y="8.4" width="1.44" height="1.44" />
            <rect x="13.2" y="8.4" width="1.44" height="1.44" />
            <rect x="16.08" y="5.52" width="1.44" height="1.44" />
            <rect x="16.08" y="6.96" width="1.44" height="1.44" />
            <rect x="16.08" y="8.4" width="1.44" height="1.44" />
            <rect x="18.96" y="5.52" width="1.44" height="3.6" />
            <rect x="18.96" y="6.96" width="1.44" height="1.44" />
            <rect x="18.96" y="8.4" width="1.44" height="1.44" />
            <rect x="16.08" y="4.08" width="1.44" height="1.44" />
            <rect x="16.08" y="2.64" width="1.44" height="6.3" />
            <rect x="21.84" y="5.52" width="1.44" height="1.44" />
            <rect x="21.84" y="6.96" width="1.44" height="1.44" />
            <rect x="21.84" y="3.69" width="1.44" height="6.15" />
            <rect x="21.84" y="4.08" width="1.44" height="1.44" />
            <rect x="16.94" y="2.64" width="6.34" height="1.44" />
            <rect x="17.52" y="2.64" width="1.44" height="1.44" />
            <rect x="18.96" y="2.64" width="1.44" height="1.44" />
            <rect x="20.4" y="2.64" width="1.44" height="1.44" />
        </g>
    </svg>
);

/* ─────────────────────── INDIVIDUAL LOGO LETTER E ─────────────────────── */
export const EIcon = ({ color = "currentColor", style = {} }) => (
    <svg viewBox="7.44 2.64 7.2 7.2" fill={color} style={{ height: "0.74em", width: "auto", display: "inline-block", verticalAlign: "-0.02em", marginRight: "0.02em", ...style }}>
        <g>
            <rect x="13.2" y="5.52" width="1.44" height="1.44" />
            <rect x="11.76" y="5.52" width="1.44" height="1.44" />
            <rect x="10.32" y="5.52" width="1.44" height="1.44" />
            <rect x="8.88" y="5.52" width="1.44" height="1.44" />
            <rect x="7.44" y="5.52" width="6.95" height="1.44" />
            <rect x="13.2" y="2.64" width="1.44" height="1.44" />
            <rect x="11.76" y="2.64" width="1.44" height="1.44" />
            <rect x="10.32" y="2.64" width="1.44" height="1.44" />
            <rect x="8.88" y="2.64" width="1.44" height="1.44" />
            <rect x="7.44" y="2.64" width="7.2" height="1.44" />
            <rect x="7.44" y="6.34" width="1.44" height="2.51" />
            <rect x="7.44" y="8.4" width="6.39" height="1.44" />
            <rect x="8.88" y="8.4" width="1.44" height="1.44" />
            <rect x="10.32" y="8.4" width="1.44" height="1.44" />
            <rect x="11.76" y="8.4" width="1.44" height="1.44" />
            <rect x="13.2" y="8.4" width="1.44" height="1.44" />
        </g>
    </svg>
);

/* ─────────────────────── INDIVIDUAL LOGO LETTER M ─────────────────────── */
export const MIcon = ({ color = "currentColor", style = {} }) => (
    <svg viewBox="16.08 2.64 7.2 7.2" fill={color} style={{ height: "0.74em", width: "auto", display: "inline-block", verticalAlign: "-0.02em", marginRight: "0.02em", ...style }}>
        <g>
            <rect x="16.08" y="5.52" width="1.44" height="1.44" />
            <rect x="16.08" y="6.96" width="1.44" height="1.44" />
            <rect x="16.08" y="8.4" width="1.44" height="1.44" />
            <rect x="18.96" y="5.52" width="1.44" height="3.6" />
            <rect x="18.96" y="6.96" width="1.44" height="1.44" />
            <rect x="18.96" y="8.4" width="1.44" height="1.44" />
            <rect x="16.08" y="4.08" width="1.44" height="1.44" />
            <rect x="16.08" y="2.64" width="1.44" height="6.3" />
            <rect x="21.84" y="5.52" width="1.44" height="1.44" />
            <rect x="21.84" y="6.96" width="1.44" height="1.44" />
            <rect x="21.84" y="3.69" width="1.44" height="6.15" />
            <rect x="21.84" y="4.08" width="1.44" height="1.44" />
            <rect x="16.94" y="2.64" width="6.34" height="1.44" />
            <rect x="17.52" y="2.64" width="1.44" height="1.44" />
            <rect x="18.96" y="2.64" width="1.44" height="1.44" />
            <rect x="20.4" y="2.64" width="1.44" height="1.44" />
        </g>
    </svg>
);

